import React from 'react'

const FooterText = ({cinemaData}) => {
    const { cinema } = cinemaData
    let isNotFirst = false
    const keyArray = ['name', 'telephone', 'street_no', 'postcode', 'town']

    return keyArray.map((key, index) => {
        if(_.has(cinema, key) && cinema[key]) {
            if(isNotFirst) {
                return ([
                    <span key={index + "a"} className="devider"> - </span>,
                    <span key={index + "b"}>{cinema[key]}</span>
                ])
            } else {
                isNotFirst = true
                return <span key={index}>{cinema[key]}</span>
            }
        }
    })
}

export default FooterText